module.exports = __webpack_public_path__ + "static/data/data.a382a88.json";


//////////////////
// WEBPACK FOOTER
// ./src/config/data.json
// module id = 7jAL
// module chunks = 1